import script from "./MapWithSinglePoint.vue?vue&type=script&lang=ts&setup=true"
export * from "./MapWithSinglePoint.vue?vue&type=script&lang=ts&setup=true"

import "./MapWithSinglePoint.vue?vue&type=style&index=0&id=d78bc57c&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d78bc57c"]])

export default __exports__